module.exports = __webpack_public_path__ + "static/media/Executy.6e9db95a.png";